export const playVideo = (modal: HTMLElement, player: YT.Player) => {
    modal.classList.add('active')
    player.playVideo()
}

export const closeVideo = (modal: HTMLElement, player: YT.Player) => {
    modal.classList.remove('active')
    player.stopVideo()
}

const addPaddingToPageBottom = (container: HTMLElement, height: number): void => {
    container.style.paddingBottom = window.innerWidth >= 992 ? `${height + 32}px` : '32px'
}

const resizeRelevantGridItem = (item: HTMLElement, grid: HTMLElement): void => {
    const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'))
    const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'))
    const rowSpan = Math.ceil((item.querySelector('.relevant-large')!
        .getBoundingClientRect().height + rowGap) / (rowHeight + rowGap))
    item.style.gridRowEnd = 'span ' + rowSpan
}

export const resizeRelevantGrid = (grid: HTMLElement): void => {
    const items: NodeListOf<HTMLElement> = grid.querySelectorAll('.article__relevant--item')

    items.forEach(item => resizeRelevantGridItem(item, grid))

    const container = document.querySelector('.article__container')

    if (! container || ! (container instanceof HTMLElement)) {
        return
    }

    addPaddingToPageBottom(container, grid.offsetHeight)
}

export async function writeTextToClipboard(text: string): Promise<boolean> {
    if (! navigator.clipboard || ! navigator.clipboard.writeText) {
        return false
    }

    return navigator.clipboard
        .writeText(text)
        .then(() => true)
        .catch(() => {
            console.error('Async: Error copying text to clipboard')
            return false
        })
}
